import React from "react";
import { Shield, ShieldAlert, Users } from "lucide-react";
import ModerationCard from "@/components/ModerationCard";
import AutoModCard from "@/components/AutoModCard";
import StaffCard from "@/components/StaffCard";
import ChannelChatSettings from "@/components/ChannelChatSettings";
import { SectionBlock } from "./Channel";

/**
 * Moderation — wraps the four existing moderation surfaces so a streamer
 * doesn't have to hop between screens.
 */
export default function Moderation() {
  return (
    <div className="space-y-6 max-w-4xl" data-testid="section-moderation">
      <SectionBlock icon={ShieldAlert} title="AutoMod & Filters" color="orange">
        <AutoModCard />
      </SectionBlock>

      <SectionBlock icon={Shield} title="Manual Moderation" color="cyan">
        <ModerationCard />
      </SectionBlock>

      <SectionBlock icon={Shield} title="Chat Rules" color="pink">
        <ChannelChatSettings />
      </SectionBlock>

      <SectionBlock icon={Users} title="Channel Staff" color="volt">
        <StaffCard />
      </SectionBlock>
    </div>
  );
}
